import React from 'react';
import { Stack, Link, Text } from 'components/Elements';
import { Form, FormInput, Submit, Checkbox, useForm } from 'components/Form';
import { useTranslator } from 'components/LanguageProvider';

export const MediaCenter = () => {
    const t = useTranslator();
    const { success, error, busy, onSubmit } = useForm(process.env.REACT_APP_MEDIA_CENTER_URL);
    return (
        <Form onSubmit={onSubmit}>
            <Stack>
                {error && <Text.Body color="red">{error}</Text.Body>}
                {success && <Text.Body color="red">{t("more.mediaCenter.success")}</Text.Body>}
                <FormInput label={t("more.mediaCenter.fullName")} type="text" required name="name" id="fullName" />
                <FormInput label={t("more.mediaCenter.email")} type="email" required name="email" id="email" />
                <FormInput label={t("more.mediaCenter.pressName")} type="text" required name="pressName" id="pressName" />
                <FormInput label={t("more.mediaCenter.message")} type="text" name="message" id="message" />
                <Checkbox
                    required
                    label={
                        <>
                            {t("more.mediaCenter.termsText")} <Link textDecoration="underline" to="/more/terms-of-use">{t("more.mediaCenter.termsLink")}</Link>
                        </>
                    }
                />
                <Submit disabled={busy}>
                    {t("more.mediaCenter.signUp")}
                </Submit>
            </Stack>
        </Form >
    )
}